// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__kZ20V","h2":"Heading_h2__hzfTU","h3":"Heading_h3__SprDg","h4":"Heading_h4__9X8bX","h5":"Heading_h5__Wf6fW","h6":"Heading_h6__qgZc6"};